// base_info_view 1 
import React, { useRef, useState, useEffect } from 'react'

import BaseCategoryMenu1 from "./base_category_menu_1"

import { } from 'react-bootstrap'
const BaseInfoView3_1 = ({
    data = [
        {
            key: "empty_draft",
            label: "進行中/歷史 空白建立",
            total: "0/0", // 雙數字
            badgeClassname: "bg-blue-100 text-blue-800"
        },
        {
            key: "ai_generated",
            label: "進行中/歷史 AI生成",
            total: "0/0",
            badgeClassname: "bg-purple-100 text-purple-800"
        },
        {
            key: "system_default",
            label: "進行中/歷史 系統預設",
            total: "5/0/500", // 三段數字
            badgeClassname: "bg-green-100 text-green-800"
        }],
    allLabel = "全部",
    total = 0,
    defaultValue = "",
    onChange = () => { },
    showAllLabel
}) => {

    return (<BaseCategoryMenu1
        data={data}
        total={total}
        allLabel={allLabel}
        defaultValue={defaultValue}
        showAllLabel={showAllLabel}
        onChange={onChange}
    />)
}
export default BaseInfoView3_1
